import React from 'react';
import LegalPageShell from '../components/LegalPageShell';

const sections = [
  {
    num: 1,
    title: 'Subscription Plans (30-day digital licences)',
    content: (
      <>
        <p>Each plan grants time-bound access to AI-narrated personalised astrology services on the Taraanaya web and mobile platforms. Prices are inclusive of 18% GST (SAC 998599).</p>
        <table>
          <tbody>
            <tr><th>Plan</th><th>Price (INR)</th><th>What you get</th></tr>
            <tr>
              <td>Starter</td>
              <td>&#8377;199 / 30 days</td>
              <td>AI-narrated past life-story video; basic Vedic chart insights; limited Sage AI questions</td>
            </tr>
            <tr>
              <td>Premium</td>
              <td>&#8377;599 / 30 days</td>
              <td>Everything in Starter + 12-month Future Reels (drip) + 8 domain insights</td>
            </tr>
            <tr>
              <td>Ultimate</td>
              <td>&#8377;999 / 30 days</td>
              <td>Everything in Premium + complete life-timeline mahadasha breakdown + priority Sage AI</td>
            </tr>
          </tbody>
        </table>
        <p><a href="/refund-policy">7-day refund</a> available if you have not consumed the personalised content.</p>
      </>
    ),
  },
  {
    num: 2,
    title: 'Sage AI Question Credit Packs (no expiry)',
    content: (
      <>
        <p>Sage AI is a personalised Vedic-astrology assistant. Each question consumes ~100 credits. Credits never expire and can be used alongside any subscription plan.</p>
        <table>
          <tbody>
            <tr><th>Pack</th><th>Price (INR)</th><th>Credits</th><th>~ Questions</th></tr>
            <tr><td>Small</td><td>&#8377;199</td><td>300</td><td>3</td></tr>
            <tr><td>Medium</td><td>&#8377;599</td><td>1,000</td><td>10</td></tr>
            <tr><td>Large</td><td>&#8377;999</td><td>1,500</td><td>15</td></tr>
          </tbody>
        </table>
        <p>Credits are non-transferable and have no monetary value outside the platform. Once added to your wallet they are non-refundable.</p>
      </>
    ),
  },
  {
    num: 3,
    title: 'Payment Methods',
    content: (
      <ul>
        <li><strong>Web (taraanaya.ai):</strong> Razorpay &mdash; UPI, Cards, Net Banking, Wallets, EMI.</li>
        <li><strong>Android:</strong> Google Play Billing &mdash; UPI, Cards, Wallets, Carrier billing.</li>
        <li><strong>iOS:</strong> Apple In-App Purchase &mdash; the payment instrument linked to your Apple ID.</li>
      </ul>
    ),
  },
  {
    num: 4,
    title: 'Taxes &amp; Invoicing',
    content: (
      <p>
        All prices are in Indian Rupees (INR) and are inclusive of 18% Goods &amp; Services Tax (GST)
        under SAC 998599 &mdash; <em>Other professional, technical and business services</em>. A GST
        invoice is issued automatically to your registered email after each successful payment.
        Business customers can request a B2B invoice with their GSTIN by writing to
        {' '}<a href="mailto:taraanaya@taraanaya.ai">taraanaya@taraanaya.ai</a>.
      </p>
    ),
  },
  {
    num: 5,
    title: 'Cancellation &amp; Refunds',
    content: (
      <p>
        Auto-renewing subscriptions on Google Play and Apple can be cancelled at any time in your
        account&rsquo;s subscription settings, at least 24 hours before the next billing cycle. Web
        subscriptions are non-auto-renewing. See the full
        {' '}<a href="/refund-policy">Refund &amp; Cancellation Policy</a> for details.
      </p>
    ),
  },
  {
    num: 6,
    title: 'FAQ',
    content: (
      <ul>
        <li><strong>Can I upgrade my plan mid-cycle?</strong> Yes &mdash; the upgrade is treated as a top-up; the original plan amount is not credited back.</li>
        <li><strong>Do credits expire?</strong> No &mdash; Sage AI credits never expire.</li>
        <li><strong>Can I gift a subscription?</strong> Not yet &mdash; coming soon.</li>
        <li><strong>Is GST included?</strong> Yes &mdash; all displayed prices are inclusive of 18% GST.</li>
        <li><strong>How do I cancel auto-renewal?</strong> See the <a href="/refund-policy">Refund Policy</a> &sect; 5 for platform-specific steps.</li>
      </ul>
    ),
  },
];

export default function PricingPage() {
  return (
    <LegalPageShell
      title="Pricing &amp; Plans"
      subtitle="Transparent, GST-inclusive pricing for Taraanaya&rsquo;s digital astrology services."
      sections={sections}
      dataTestId="pricing-page"
    />
  );
}
